import { translations } from './translations';
import { readLocale } from './localeStorage';
import type { Locale, TranslateParams, TranslationKey } from './types';

function interpolate(template: string, params?: TranslateParams) {
  if (!params) {
    return template;
  }
  return Object.entries(params).reduce(
    (result, [key, value]) => result.replaceAll(`{${key}}`, String(value)),
    template,
  );
}

export function createTranslator(locale?: Locale) {
  const activeLocale = locale ?? readLocale();
  return (key: TranslationKey, params?: TranslateParams) => {
    const template =
      translations[activeLocale][key] ??
      translations.en[key] ??
      translations.ru[key] ??
      String(key);
    return interpolate(template, params);
  };
}

export function translate(key: TranslationKey, params?: TranslateParams, locale?: Locale) {
  return createTranslator(locale)(key, params);
}
